<template>
  <div class="all">
    <div class="swiper" @click="gologinPage()">
      <el-carousel trigger="click" height="33vw">
        <el-carousel-item v-for="(item, index) in img" :key="index">
          <img class="swiper_img" v-lazy="item.img" alt="" /></el-carousel-item>
      </el-carousel>
    </div>
    <div class="apply">
      <div class="apply_left">
        <div class="bid" @click="gologinPage()">
          <h3>投标保函</h3>
          <p>轻松三步走，一键申请秒出函</p>
          <div class="app_btn">立即申请&nbsp;&nbsp;></div>
        </div>
        <div class="pay" @click="gologinPage()">
          <div class="pay_left">
            <h3>预付款保函</h3>
            <div class="app_btn">立即申请&nbsp;&nbsp;></div>
          </div>
          <div class="pay_right" @click="gologinPage()">
            <h3>农民工工资支付保函</h3>
            <div class="app_btn">立即申请&nbsp;&nbsp;></div>
          </div>
        </div>
      </div>
      <div class="apply_right" @click="gologinPage()">
        <div class="apply__top">
          <h3>履约保函</h3>
          <p>免保证金，低至5000元起</p>
        </div>
        <div class="app_btn">立即申请&nbsp;&nbsp;></div>
      </div>
    </div>
    <div class="outlineFromBox" style="margin: 45px auto">
      <!-- 可视化流动地图 -->
      <LookMap></LookMap>
      <!-- <div class="xianOne"> -->
      <!-- <form style="top:270px;left:-78px" class="fieldsetFormBoxOne"> -->
      <!-- <fieldset> -->
      <!-- <legend>内蒙古</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">呼和浩特、巴彦淖尔</p> -->
      <!-- </fieldset> -->
      <!-- </form> -->
      <!-- <form style="top:420px;left:-130px" class="fieldsetFormBoxTwo"> -->
      <!-- <fieldset> -->
      <!-- <legend>新疆</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">昌吉</p> -->
      <!-- </fieldset> -->
      <!-- </form> -->
      <!-- <form style="top:650px;left:-50px" class="fieldsetFormBoxThree"> -->
      <!-- <fieldset> -->
      <!-- <legend>四川省</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">泸州、广元、遂宁</p> -->
      <!-- </fieldset> -->
      <!-- </form> -->
      <!-- </div> -->
      <!-- <div class="xianTwo"> -->
      <!-- <form style="top:360px;right:-178px" class="fieldsetFormBoxFour"> -->
      <!-- <fieldset> -->
      <!-- <legend>河北省</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">石家庄、保定、邢台、邯郸、沧州、衡水</p> -->
      <!-- </fieldset> -->
      <!-- </form> -->
      <!-- <form style="top:500px;right:-68px" class="fieldsetFormBoxFive"> -->
      <!-- <fieldset> -->
      <!-- <legend>安徽</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">宿州</p>
          </fieldset> -->
      <!-- </form> -->
      <!-- <form style="top:640px;right:-78px" class="fieldsetFormBoxSix"> -->
      <!-- <fieldset> -->
      <!-- <legend>广东省</legend> -->
      <!-- <p style="width:100%;height:60px;box-sizing:border-box;padding:10px 5px">广州、东莞</p> -->
      <!-- </fieldset> -->
      <!-- </form> -->
      <!-- </div> -->
      <!-- 底部数据 -->
      <div class="bottomFourText">
        <dl>
          <dt>4年</dt>
          <dd>4年专注电子保函服务</dd>
        </dl>
        <dl>
          <dt>12个</dt>
          <dd>业务分布12个省、自治州</dd>
        </dl>
        <dl>
          <dt>6157家</dt>
          <dd>累计注册企业6000+</dd>
        </dl>
        <dl>
          <dt>30000份</dt>
          <dd>累计出具30000+保函</dd>
        </dl>
      </div>
    </div>
    <!-- 发展历史 -->
    <history></history>
    <!-- 优势 -->
    <advantage></advantage>
    <banner-swip></banner-swip>
    <!-- 最新资讯 -->
    <information></information>
    <!-- 弹窗通知 -->
    <WorkspaceJsonUpBox></WorkspaceJsonUpBox>
    <div class="footer">
      <img v-lazy="require('@/assets/home/footer.png')" alt=" " @click="goLoginPage()" />
    </div>



  </div>
</template>

<script>
import Advantage from "./components/advantage.vue";
import history from "./components/history.vue";
import Information from "./components/information.vue";
import BannerSwip from "./components/bannerSwip.vue";
import LookMap from "./components/LookMap.vue";
import WorkspaceJsonUpBox from "./components/upBox.vue";
export default {
  components: {
    history,
    Advantage,
    Information,
    BannerSwip,
    LookMap,
    WorkspaceJsonUpBox,
  },
  data() {
    return {
      img: [
        {
          img: require("@/assets/banner1.png"),
          url: "/path",
        },
        {
          img: require("@/assets/函驿通banner2.jpg"),
        },
        {
          img: require("@/assets/函驿通1.jpg"),
        },
      ],
    };
  },
  created() { },
  mounted() { },
  methods: {
    goLoginPage() {
      // window.open('http://www.haneton.com:18080/warrantee/loginController.do?loginPage')
      window.open(
        "https://www.haneton.com/warrantee/loginController.do?loginPage"
      );
    },
    gologinPage() {
      // window.open('http://www.haneton.com:18080/warrantee/loginController.do?loginPage')
      window.open(
        "https://www.haneton.com/warrantee/loginController.do?loginPage"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.outlineFromBox {
  width: 100%;
  position: relative;
  height: 1000px;
}

h3 {
  font-size: 24px;
}

.all {
  width: 100%;
  height: 100%;

  .apply {
    margin-top: 15px;
    display: flex;
    font-weight: bold;
    text-align: left;
    cursor: pointer;

    .app_btn {
      font-size: 15px;
      color: #eacd76;
    }

    .apply_left {
      width: 60%;

      P {
        font-size: 15px;
      }

      .bid {
        height: 308px;
        padding: 40px 0 40px 30%;
        background-image: url("../../assets/home/pay1.png");
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 0px 10px 0px;

        p {
          margin-top: 20px;
        }

        .app_btn {
          margin-top: 90px;
        }
      }

      .bid:hover .app_btn {
        color: #164ebc;
      }

      .pay {
        display: flex;
        height: 173px;

        .app_btn {
          margin: 25px 0 40px 0;
        }

        .pay_left {
          width: 55%;
          padding: 40px 0 0 30%;
          background-image: url("../../assets/home/pay3.png");
          background-repeat: no-repeat;
          background-size: cover;
          margin-right: 10px;
        }

        .pay_left:hover .app_btn {
          color: #164ebc;
        }

        .pay_right {
          width: 45%;
          padding: 40px 0 0 20px;
          background-image: url("../../assets/home/pay4.png");
          background-repeat: no-repeat;
          background-size: cover;
        }

        .pay_right:hover .app_btn {
          color: #164ebc;
        }
      }
    }

    .apply_right {
      background-color: #19b2d8;
      width: 40%;
      padding: 30px 0 58px 30px;
      display: flex;
      margin-left: 10px;
      flex-direction: column;
      justify-content: space-between;
      background-image: url("../../assets/home/pay2.png");
      background-repeat: no-repeat;
      background-size: cover;

      p {
        margin-top: 20px;
      }
    }

    .apply_right:hover .app_btn {
      color: #164ebc;
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper_img {
    width: 100%;
    height: auto;
  }

  ::v-deep .el-carousel__indicator.is-active button {
    width: 40px;
    height: 3px;
    background-color: #eacd76;
  }

  ::v-deep .el-carousel__button {
    width: 10px;
    background-color: #fff;
  }

  .footer {

    // width: 100%;
    // height: 298px;
    img {
      width: 100%;
      cursor: pointer;
      height: 100%;
      object-fit: cover;
    }
  }
}

.bottomFourText {
  width: 70%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}

.bottomFourText dt {
  color: #ffcb4e;
  font-size: 38px;
}

.bottomFourText dt,
dd {
  text-align: center;
}

.xianOne {
  position: absolute;
  top: 0;
  left: 30%;
  width: 1px;
  height: 1000px;
}

.xianTwo {
  position: absolute;
  top: 0;
  right: 30%;
  width: 1px;
  height: 1000px;
}

.fieldsetFormBoxOne,
.fieldsetFormBoxTwo,
.fieldsetFormBoxThree,
.fieldsetFormBoxFour,
.fieldsetFormBoxFive,
.fieldsetFormBoxSix {
  position: absolute;
  width: 200px;
  height: 70px;
}
</style>
